// extracted by mini-css-extract-plugin
module.exports = {"deploymentBanner":"styles_deploymentBanner__ljyG9","deploymentBanner__paragraph":"styles_deploymentBanner__paragraph__1donV"};